import {
	type ClientPropertyCottageDetailResponseDTO,
	ClientPropertyTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BuildingEditFormFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingEditFormFields";
import { useEditCottageForm } from "web_myplann/Portfolio/Forms/CottageForm/useEditCottageForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditCottageFormProps = {
	propertyId: number;
	property: ClientPropertyCottageDetailResponseDTO;
	detailRoute: string;
};

export const EditCottageForm = ({
	propertyId,
	property,
	detailRoute,
}: EditCottageFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending, leaveConfirmation } = useEditCottageForm({
		propertyId,
		property,
		detailRoute,
	});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditRealEstate.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
			leaveConfirmation={leaveConfirmation}
		>
			<BuildingEditFormFields
				control={form.control}
				type={ClientPropertyTypeEnum.Cottage}
			/>
		</PortfolioFormShell>
	);
};
